import * as React from 'react';
import { PikTabGroup } from '../../ui/pik_tab_group/pik_tab_group';
import { TComponentWithTabsProps } from '../../types/tabs';
import { tabs, tabsContent } from './config';
import { THomeTabId } from './types';
import { VideoPlayer } from '../video-player';

export class WhatIsHome extends React.Component<TComponentWithTabsProps> {
  private handleTabToggle = (value: THomeTabId) =>
    this.props.changeTabs({
      ...this.props.tabs,
      home: value,
    });

  public render() {
    const {
      tabs: { home: activeTab },
    } = this.props;
    const videoUrl = tabsContent[activeTab].video;

    return (
      <React.Fragment>
        <PikTabGroup activeTab={activeTab} onTabClick={this.handleTabToggle} tabs={tabs} />
        <VideoPlayer videoURL={videoUrl} />
      </React.Fragment>
    );
  }
}
